import { RoleList } from '@/admin/entities/role/RoleList';
import { UserList } from '@/admin/entities/user/UserList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';


export const GroupDetail = () => {

  const { entityObj } = useEntityMgr();
  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'usersTab', label: 'Users', content: <UserList groupObj={entityObj} /> },
    { id: 'rolesTab', label: 'Roles', content: <RoleList groupObj={entityObj} /> },
  ];


  return (
    <EntityDetail key={entityObj} tabSpecs={tabSpecs} />
  )
}